module.exports = __webpack_public_path__ + "static/img/fingerpost_express_7.04505ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fingerpost/fingerpost_express_7.jpg
// module id = q8LA
// module chunks = 0